// This file was autogenerated from running npm run sync-files.
// DO NOT EDIT THIS FILE DIRECTLY.
// Edit the source file below and then run `npm run sync-files`
// Source: ui/oopsyraidsy/data/04-sb/trial/seiryu-ex.ts

import ZoneId from '../../../../../resources/zone_id';
import { OopsyData } from '../../../../../types/data';
import { OopsyTriggerSet } from '../../../../../types/oopsy';

// TODO: Infirm Soul (ABCB) hitting Cursekeeper (ABC9) target?
// TODO: taking Forbidden Arts #2 (ABBF) with vuln stack from #1?

export type Data = OopsyData;

// Seiryu Unreal
const triggerSet: OopsyTriggerSet<Data> = {
  zoneId: ZoneId.TheWreathOfSnakesUnreal,
  damageWarn: {
    'SeiryuUn Onmyo Sigil 1': 'ABF8', // centered "get out" circle (phase 1)
    'SeiryuUn Onmyo Sigil 2': 'ABFA', // centered "get out" circle (phase 2 first)
    'SeiryuUn Onmyo Sigil 3': 'ABFD', // centered "get out" circle (phase 2 second)
    'SeiryuUn Serpent-Eye Sigil 1': 'ABFC', // donut (phase 2 first)
    'SeiryuUn Serpent-Eye Sigil 2': 'ABFB', // donut (phase 2 second)
    'SeiryuUn Fortune-Blade Sigil': 'ABD9', // Kuji-Kiri (ABD8) lines
    'SeiryuUn Calamity-Blade Sigil': 'ABDA', // Kuji-Kiri (ABD8) follow-up lines
    'SeiryuUn Iwa-No-Shiki 100-Tonze Swing': 'ABE4', // centered circles
    'SeiryuUn Ten-No-Shiki Yama-Kagura': 'ABFE', // blue lines during midphase / final phase adds
    'SeiryuUn Numa-No-Shiki Stoneskin': 'ABEB', // failing to silence add
    'SeiryuUn Great Typhoon 1': 'ABEF', // outside ring of water during Coursing River
    'SeiryuUn Great Typhoon 2': 'ABF0', // outside ring of water during Coursing River
    'SeiryuUn Great Typhoon 3': 'ABF1', // outside ring of water during Coursing River
    'SeiryuUn Great Typhoon 4': 'ABF2', // outside ring of water during Coursing River
    'SeiryuUn Yama-No-Shiki Handprint 1': 'ABDE', // half arena cleave
    'SeiryuUn Yama-No-Shiki Handprint 2': 'ABDF', // half arena cleave
    'SeiryuUn Force Of Nature': 'ABE1', // standing in the middle circle during knockback (380A)
    'SeiryuUn Serpent Descending Circle': 'ABD5', // baited circles with towers
    'SeiryuUn Serpent\'s Jaws': 'ABD7', // failing towers
  },
  shareWarn: {
    'SeiryuUn Serpent Descending Spread': 'ABD4', // spread markers
    'SeiryuUn Aka-No-Shiki Red Rush': 'ABE8', // tether charge
    'SeiryuUn Iwa-No-Shiki Kanabo': 'ABE5', // tether which targets a large conal cleave
  },
  shareFail: {
    'SeiryuUn Infirm Soul': 'ABCB', // tank buster circular cleave
  },
  soloWarn: {
    'SeiryuUn Ao-No-Shiki Blue Bolt': 'ABE7', // tether share
    'SeiryuUn Forbidden Arts 1': 'ABBE', // line stack share hit 1
    'SeiryuUn Forbidden Arts 2': 'ABBF', // line stack share hit 2
  },
};

export default triggerSet;
